import { useDispatch, useSelector } from "react-redux";
import CardHeader from "../../components/atoms/cardHeader";
import { Pagination } from "../../components/atoms/pagination";
import { ReviewTable } from "./components/ReviewTable";
import { useEffect, useState } from "react";
import CardWrapper from "../../components/molecules/CardWrapper";
import { ReviewThunk } from "../../store/thunks/reviewThunk";


const Reviews = () => {
  const dispatch = useDispatch();
  const [offset, setOffset] = useState(0)
  const { loading, error, list: List, pageInfo } = useSelector(
    (state) => state.reviews
  );
  useEffect(() => {
    dispatch(
      ReviewThunk({
        paginationFilter: { limit: 10, offset: offset, order: "DESC" },
      })
    );
  }, [offset]);
  return (
    <>
      <div className="content d-flex flex-column flex-column-fluid">
        <CardWrapper>
          <CardHeader name={"Reviews List"} tooltipText={"View customer ratings, reviews, and feedback for your products."}/>
          <div className="card-body p-4">
            <ReviewTable list={List} offset={offset} loading={loading} />
            <Pagination pageInfo={pageInfo} offset={offset} setOffset={setOffset} />
          </div>
        </CardWrapper>
      </div>
    </>
  );
};

export default Reviews;
